<template>
  <div>
    <h2>Available sources</h2>
    <div class="row">
      <div class="col l4"  v-for="source in sources" :key="source.id">
        <div class="card">
          <div :class="['card-image', source.imageBackground]">
            <img :src="source.getLogo()">
          </div>
          <div class="card-stacked">
            <div class="card-content">
              <h4>{{ source.label }}</h4>
              <p>{{ source.extendedDescription }}</p>
            </div>
            <div class="card-action">
              <router-link :to="{name: 'connect.source', params: {sourceId: source.id}}">Connect</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sources from "@/sources"

export default {
  computed: {
    sources () {
      return sources.all()
    }
  }
}
</script>
<style scoped>
.card .card-image {
  padding: 1em;
  overflow: hidden;
}
.card-image img {
  height: 3em;
  width: auto;
  margin: 0 auto;
}
</style>
